import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { MagicMarkdown } from '../common/MagicMarkdown';
import { AiDisclaimer } from '../common/AiDisclaimer';

// Stencil's radius scale stops at `sui-rounded-xl` (12px), so the card's corner is set here. It was
// 32px, which read as a pill-shaped panel next to the 8px question tiles; 16px is the design's
// softer corner without that.
const CARD_STYLE = { borderRadius: '16px' };

export const Summary = ({ title, body }) => {
  return (
    // The disclaimer sits outside the card on the banner background, 12px below it, and its right
    // edge lines up with the card's.
    <div className="sui-flex sui-flex-col sui-gap-3">
      <div
        className="sui-flex sui-flex-col sui-gap-4 sui-p-8 sui-bg-primary sui-text-primary"
        style={CARD_STYLE}
      >
        {title && (
          <Typography
            component="h3"
            variant="body-base"
            weight="bold"
            height="tight"
            color="primary"
          >
            {title}
          </Typography>
        )}
        <MagicMarkdown>{body}</MagicMarkdown>
      </div>
      <AiDisclaimer />
    </div>
  );
};

Summary.displayName = 'Summary';

Summary.propTypes = {
  /** Plain-text `Summary` title, shown as the card heading (its own API field, not markdown). */
  title: PropTypes.string,
  /** The AI answer as a markdown string. */
  body: PropTypes.string,
};
